import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);
import i18n from './i18n/i18n'
Vue.use(i18n)

const routerOptions = [{
        path: '/login',
        name: 'login',
        meta: {
            requiresAuth: false,
            breadcrumb: [{ parent: 'เข้าสู่ระบบ', label: '' }]
        },
        exact: true,
        component: () =>
            import ('./pages/Login.vue')
    },
    {
        path: '/map-disaster',
        name: 'map-disaster',
        meta: {
            requiresAuth: true,
            breadcrumb: [{ parent: 'แสดงตำแหน่ง', label: 'ร้านค้า, ผู้ใช้งานทั่วไป' }]
        },
        exact: true,
        component: () =>
            import ('./components/DisasterMap.vue')
    },
    {
        path: '/information/system',
        name: 'information-system',
        meta: {
            requiresAuth: true,
            breadcrumb: [{ parent: 'จัดการข้อมูล', label: 'ข้อมูลระบบพื้นฐาน' }]
        },
        exact: true,
        component: () =>
            import ('./components/Information/System/InformationSystem.vue')
    },
    {
        path: '/information/user',
        name: 'information-user',
        meta: {
            requiresAuth: true,
            breadcrumb: [{ parent: 'จัดการข้อมูล', label: 'ผู้ใช้งานทั่วไป' }]
        },
        exact: true,
        component: () =>
            import ('./components/Information/System/InformationUsers.vue')
    },
    {
        path: '/information/shop',
        name: 'information-shop',
        meta: {
            requiresAuth: true,
            breadcrumb: [{ parent: 'จัดการข้อมูล', label: 'ร้านค้า/บริการ' }]
        },
        exact: true,
        component: () =>
            import ('./components/Information/System/InformationShops.vue')
    },
    {
        path: '/policy',
        name: 'policy',
        meta: {
            requiresAuth: true,
            breadcrumb: [{ parent: 'นโยบายความเป็นส่วนตัว', label: '' }]
        },
        exact: true,
        component: () =>
            import ('./pages/Policy.vue')
    }
];

const router = new Router({
    mode: 'history',
    routes: [
        ...routerOptions,
        {
            path: '*',
            redirect: '/login'
        }
    ],
    scrollBehavior() {
        return { x: 0, y: 0 };
    }
});

router.beforeEach((to, from, next) => {
    const requiresAuth = to
        .matched
        .some(record => record.meta.requiresAuth)

    var session = localStorage.getItem('userSession')
    if (requiresAuth && session == null) {

        if (to.path == '/policy') {
            next()
        } else {
            next('/login')
        }

    }

    next()
})

export default router;